import { LitElement, html, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';

@customElement('cp-page-login')
export class CpPageLogin extends LitElement {
  createRenderRoot() { return this; }

  @property({ type: Boolean }) sessionExpired = false;
  @state() private _errorMessage = '';

  connectedCallback() {
    super.connectedCallback();
    // Check for OAuth error in URL params
    const params = new URLSearchParams(window.location.search);
    const error = params.get('error');
    if (error === 'access_denied') {
      this._errorMessage = 'Zugriff verweigert. Bitte versuchen Sie es erneut.';
      // Clean URL
      window.history.replaceState({}, '', window.location.pathname);
    }
  }

  private _handleLogin(): void {
    window.location.href = '/api/auth/google';
  }

  render() {
    return html`
      <div class="cp-login-page">
        <div class="cp-login-page__card">
          <div class="cp-login-page__brand">
            <div class="cp-login-page__brand-logo">
              <img src="/pelorus-mark.svg" alt="PELORUS" width="56" height="56" />
            </div>
            <h1 class="cp-login-page__brand-name">PELORUS</h1>
            <p class="cp-login-page__brand-tagline">Predictive Engine for Learning, Orchestration, Reasoning &amp; Unified Support</p>
          </div>

          ${this.sessionExpired ? html`
            <div class="cp-login-page__expired">Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.</div>
          ` : nothing}

          ${this._errorMessage ? html`
            <div class="cp-login-page__error">${this._errorMessage}</div>
          ` : nothing}

          <button
            class="cp-login-page__google-btn"
            @click=${this._handleLogin}
          >
            <svg class="cp-login-page__google-icon" viewBox="0 0 24 24" width="20" height="20">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            Mit Google anmelden
          </button>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cp-page-login': CpPageLogin;
  }
}
